(() => {
  const observed = document.querySelectorAll('[data-shmoo-reveal]');
  if (!('IntersectionObserver' in window)) {
    observed.forEach((element) => element.classList.add('is-visible'));
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.16 });
  observed.forEach((element) => observer.observe(element));
})();
